import React from 'react';
import {
  Box,
  makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import CollegeDetails from '../profile/profileForms/CollegeQuestions';
import Layout from './components/Layout';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiCardContent-root > .MuiGrid-root': {
      display: 'flex',
      justifyContent: 'center',
    },
  }
}));

const CollegeQuestions = (props) => {
  const classes = useStyles();
  const user = useSelector((u) => u.user.user);
  const profile = useSelector((u) => u.student.profile);
  const { history } = props;
  const step = 5;

  return (
    <Layout step={step} showBack stepLabel={`Onboarding quiz - Step ${step}/7 `}>
      <Box className={classes.root}>
        <CollegeDetails
          editable
          user={user}
          college_info={profile.college_info}
          saveText="Next"
          step={step}
          onSkip={() => history.push(`/onboarding/${step + 1}`)}
          isSkip
          disableCard
          {...props}
        />
      </Box>
    </Layout>
  );
};

export default CollegeQuestions;
